<template>
  <!-- BEGIN: Side Menu-->

  <div data-scroll-to-active="true" class="main-menu menu-fixed menu-light menu-accordion menu-shadow "
    style="touch-action: none; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">
    <div
      v-if="mustChangePassword"
      class="p-3"
      style="color: #fff;"
    >
      <p class="mb-0" style="padding: 16px;">
        Change your password to unlock the admin menu.
      </p>
    </div>
    <CScrollbar
      v-else
      class="navigation navigation-main h-100"
      id="main-menu-navigation"
      data-menu="menu-navigation"
      :settings="psSettings"
      tag="ul"
    >
      <li class="nav-item" :class="{ 'link-active': currentPage === 'Dashboard' }"
        v-if="permissions.includes('dashboard')">
        <router-link :to="{ name: 'Dashboard' }" :class="currentPage === 'Dashboard' ? 'c-active' : ''" target="_self"
          :aria-current="currentPage === 'Dashboard' ? 'page' : ''">
          <i data-trigger="hover" data-toggle="tooltip" data-placement="right" class="feather-home"></i>
          <span class="menu-title">Dashboard</span>
        </router-link>
      </li>
      <li class="nav-item" :class="{ 'link-active': currentPage === 'Customers' }"
        v-if="permissions.includes('customers')">
        <router-link :to="{ name: 'Customers' }" :class="currentPage === 'Customers' ? 'c-active' : ''" target="_self"
          :aria-current="currentPage === 'Customers' ? 'page' : ''">
          <i data-trigger="hover" data-toggle="tooltip" data-placement="right" class="feather-users"></i>
          <span class="menu-title">Customers</span>
        </router-link>
      </li>
      <li class="nav-item" :class="{ 'link-active': currentPage === 'CustomerBehaviorDashboard' }"
        v-if="permissions.includes('dashboard')">
        <router-link :to="{ name: 'CustomerBehaviorDashboard' }" :class="currentPage === 'CustomerBehaviorDashboard' ? 'c-active' : ''" target="_self"
          :aria-current="currentPage === 'CustomerBehaviorDashboard' ? 'page' : ''">
          <i data-trigger="hover" data-toggle="tooltip" data-placement="right" class="feather-bar-chart-2"></i>
          <span class="menu-title">Customer Behavior</span>
        </router-link>
      </li>
      <li class="nav-item" :class="{ 'link-active': currentPage === 'TransferHolds' }"
        v-if="permissions.includes('view-transfer-holds')">
        <router-link :to="{ name: 'TransferHolds' }" :class="currentPage === 'TransferHolds' ? 'c-active' : ''" target="_self"
          :aria-current="currentPage === 'TransferHolds' ? 'page' : ''">
          <i data-trigger="hover" data-toggle="tooltip" data-placement="right" class="feather-alert-triangle"></i>
          <span class="menu-title">Transfer Holds</span>
        </router-link>
      </li>
      <li v-if="permissions.includes('payments')">
        <router-link :to="{ name: 'Payments' }" :class="currentPage === 'Payments' ? 'c-active' : ''"
          :aria-current="currentPage === 'Payments' ? 'page' : ''">
          <i data-trigger="hover" data-toggle="tooltip" data-placement="right" class="feather-credit-card"></i>
          <span class="menu-title">Transactions</span>
        </router-link>
      </li>
      <li v-if="permissions.includes('services')" class="nav-item"
        :class="{ 'link-active': currentPage === 'Services' }">
        <router-link :to="{ name: 'Services' }" :class="currentPage === 'Services' ? 'c-active' : ''" target="_self"
          :aria-current="currentPage === 'Services' ? 'page' : ''">
          <i data-trigger="hover" data-toggle="tooltip" data-placement="right" class="feather-credit-card"></i>
          <span class="menu-title">Services</span>
        </router-link>
      </li>
      <li v-if="permissions.includes('create-update-bank')" class="nav-item"
        :class="{ 'link-active': currentPage === 'Banks' }">
        <router-link :to="{ name: 'Banks' }" :class="currentPage === 'Banks' ? 'c-active' : ''" target="_self"
          :aria-current="currentPage === 'Banks' ? 'page' : ''">
          <i data-trigger="hover" data-toggle="tooltip" data-placement="right" class="feather-home"></i>
          <span class="menu-title">Banks</span>
        </router-link>
      </li>
      <li class="nav-item" :class="{ 'link-active': currentPage === 'Cards' }"
        v-if="permissions.includes('card-request')">
        <router-link :to="{ name: 'Cards' }" :class="currentPage === 'Cards' ? 'c-active' : ''" target="_self"
          :aria-current="currentPage === 'Cards' ? 'page' : ''">
          <i data-trigger="hover" data-toggle="tooltip" data-placement="right" class="feather-credit-card"></i>
          <span class="menu-title">Card Requests</span>
        </router-link>
      </li>
      <li class="nav-item" :class="{ 'link-active': currentPage === 'KiddiesAccount' }"
        v-if="permissions.includes('card-request')">
        <router-link :to="{ name: 'KiddiesAccount' }" :class="currentPage === 'KiddiesAccount' ? 'c-active' : ''" target="_self"
          :aria-current="currentPage === 'KiddiesAccount' ? 'page' : ''">
          <i data-trigger="hover" data-toggle="tooltip" data-placement="right" class="feather-credit-card"></i>
          <span class="menu-title">Kiddies Account</span>
        </router-link>
      </li>
      <li class="nav-item has-sub menu-collapsed-open" ref="utilities" v-if="permissions.includes('utility')">
        <a @click="handleClick($event, 'utilities')">
          <i class="feather-credit-card"></i>
          <span class="menu-title">Utilities</span>
        </a>
        <ul class="menu-content" @click="itemClicked">
          <li class="nav-item" v-if="permissions.includes('utility')">
            <router-link :to="{ name: 'Utility' }" :class="currentPage === 'Utility' ? 'c-active' : ''" target="_self"
              :aria-current="currentPage === 'Utility' ? 'page' : ''">
              <span class="menu-title">Quick Search</span>
            </router-link>
          </li>

          <li class="nav-item" v-if="permissions.includes('sms-list')">
            <router-link :to="{ name: 'SMSList' }" :class="currentPage === 'SMSList' ? 'c-active' : ''" target="_self"
              :aria-current="currentPage === 'SMSList' ? 'page' : ''">
              <span class="menu-title">SMS Lists</span>
            </router-link>
          </li>
        </ul>
      </li>
      <!-- <li
        class="nav-item"
        :class="{ 'link-active': currentPage === 'Utility' }"
        v-if="permissions.includes('utility')"
      >
        <router-link
          :to="{ name: 'Utility' }"
          :class="currentPage === 'Utility' ? 'c-active' : ''"
          target="_self"
          :aria-current="currentPage === 'Utility' ? 'page' : ''"
        >
          <i
            data-trigger="hover"
            data-toggle="tooltip"
            data-placement="right"
            class="feather-settings"
          ></i>
          <span class="menu-title">Utility (Quick Search)</span>
        </router-link>
      </li> -->
      <li class="nav-item has-sub menu-collapsed-open" ref="loan_management" v-if="permissions.includes('instant-loans') ||
        permissions.includes('instant-loan-wavier') ||
        permissions.includes('loan-analysis') ||
        permissions.includes('manage-loan-officer-settings')
      ">
        <a @click="handleClick($event, 'loan_management')">
          <i class="feather-credit-card"></i>
          <span class="menu-title">Instant Loans</span>
        </a>
        <ul class="menu-content" @click="itemClicked">
          <li class="nav-item" v-if="permissions.includes('instant-loans')">
            <router-link :to="{
              name: 'Loans'
            }" :class="currentPage === 'Loans' ? 'c-active' : ''" target="_self"
              :aria-current="currentPage === 'Loans' ? 'page' : ''">
              <span class="menu-title">Instant Loans</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="permissions.includes('instant-loans')">
            <router-link :to="{
              name: 'CompletedLoans'
            }" :class="currentPage === 'CompletedLoans' ? 'c-active' : ''" target="_self"
              :aria-current="currentPage === 'CompletedLoans' ? 'page' : ''">
              <span class="menu-title">Completed Loans</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="permissions.includes('instant-loans')">
            <router-link :to="{
              name: 'RefusedLoans'
            }" :class="currentPage === 'RefusedLoans' ? 'c-active' : ''" target="_self"
              :aria-current="currentPage === 'RefusedLoans' ? 'page' : ''">
              <span class="menu-title">Refused Loans</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="permissions.includes('collection-history')">
            <router-link :to="{
              name: 'CollectionHistory'
            }" :class="currentPage === 'CollectionHistory' ? 'c-active' : ''" target="_self"
              :aria-current="currentPage === 'CollectionHistory' ? 'page' : ''">
              <span class="menu-title">Collection History</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="permissions.includes('loan-analysis')">
            <router-link :to="{ name: 'LoanAnalysis' }" :class="currentPage === 'LoanAnalysis' ? 'c-active' : ''"
              target="_self" :aria-current="currentPage === 'LoanAnalysis' ? 'page' : ''">
              <span class="menu-title">Loan Analysis</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="permissions.includes('instant-loan-wavier')">
            <router-link :to="{ name: 'LoanWaivers' }" :class="currentPage === 'LoanWaivers' ? 'c-active' : ''"
              target="_self" :aria-current="currentPage === 'LoanWaivers' ? 'page' : ''">
              <span class="menu-title">Instant Loan Waivers</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="permissions.includes('loan-overview')">
            <router-link :to="{ name: 'LoanOverview' }" :class="currentPage === 'LoanOverview' ? 'c-active' : ''"
              target="_self" :aria-current="currentPage === 'LoanOverview' ? 'page' : ''">
              <span class="menu-title">Loan Overview</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="permissions.includes('loan-overview') || permissions.includes('instant-loans')">
            <router-link :to="{ name: 'NanoLoanDashboard' }" :class="currentPage === 'NanoLoanDashboard' ? 'c-active' : ''"
              target="_self" :aria-current="currentPage === 'NanoLoanDashboard' ? 'page' : ''">
              <span class="menu-title">Nano Loan Dashboard</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="permissions.includes('instant-loans')">
            <router-link :to="{ name: 'SweptLoans' }" :class="currentPage === 'SweptLoans' ? 'c-active' : ''"
              target="_self" :aria-current="currentPage === 'SweptLoans' ? 'page' : ''">
              <span class="menu-title">Swept Loans</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="permissions.includes('manage-loan-officer-settings')">
            <router-link :to="{ name: 'LoanOfficerSettings' }" :class="currentPage === 'LoanOfficerSettings' ? 'c-active' : ''"
              target="_self" :aria-current="currentPage === 'LoanOfficerSettings' ? 'page' : ''">
              <span class="menu-title">Loan Officer Settings</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="permissions.includes('nano-loan-rates')">
            <router-link :to="{ name: 'NanoLoanRates' }" :class="currentPage === 'NanoLoanRates' ? 'c-active' : ''"
              target="_self" :aria-current="currentPage === 'NanoLoanRates' ? 'page' : ''">
              <span class="menu-title">Nano Loan Rates</span>
            </router-link>
          </li>
        </ul>
      </li>
      
      <li class="nav-item has-sub menu-collapsed-open" ref="other_loan_management" v-if="permissions.includes('other-loans')
      ">
        <a @click="handleClick($event, 'other_loan_management')">
          <i class="feather-credit-card"></i>
          <span class="menu-title">Other Loans</span>
        </a>
        <ul class="menu-content" @click="itemClicked">
          <li class="nav-item" v-if="permissions.includes('other-loans')">
            <router-link :to="{
              name: 'OtherLoans'
            }" :class="currentPage === 'OtherLoans' ? 'c-active' : ''" target="_self"
              :aria-current="currentPage === 'OtherLoans' ? 'page' : ''">
              <span class="menu-title">All Other Loans</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="permissions.includes('other-loans')">
            <router-link :to="{
              name: 'ActiveOtherLoans'
            }" :class="currentPage === 'ActiveOtherLoans' ? 'c-active' : ''" target="_self"
              :aria-current="currentPage === 'ActiveOtherLoans' ? 'page' : ''">
              <span class="menu-title">Active Loans</span>
            </router-link>
          </li>
        </ul>
      </li>

      <li class="nav-item" v-if="permissions.includes('provider-balance')"
        :class="{ 'link-active': currentPage === 'provider-balance' }">
        <router-link :to="{ name: 'Balances' }" :class="currentPage === 'Balances' ? 'c-active' : ''" target="_self"
          :aria-current="currentPage === 'Balances' ? 'page' : ''">
          <i data-trigger="hover" data-toggle="tooltip" data-placement="right" class="feather-bell"></i>
          <span class="menu-title">Provider Balances</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="permissions.includes('onboard-customer')"
        :class="{ 'link-active': currentPage === 'OnboardCustomer' }">
        <router-link :to="{ name: 'OnboardCustomer' }" :class="currentPage === 'OnboardCustomer' ? 'c-active' : ''"
          target="_self" :aria-current="currentPage === 'OnboardCustomer' ? 'page' : ''">
          <i data-trigger="hover" data-toggle="tooltip" data-placement="right" class="feather-users"></i>
          <span class="menu-title">Onboard Customer</span>
        </router-link>
      </li>
      <!-- <li
        class="nav-item"
        v-if="permissions.includes('referrals')"
        :class="{ 'link-active': currentPage === 'Referrals' }"
      >
        <router-link
          :to="{ name: 'Referrals' }"
          :class="currentPage === 'Referrals' ? 'c-active' : ''"
          target="_self"
          :aria-current="currentPage === 'Referrals' ? 'page' : ''"
        >
          <i
            data-trigger="hover"
            data-toggle="tooltip"
            data-placement="right"
            class="feather-users"
          ></i>
          <span class="menu-title">Referrals</span>
        </router-link>
      </li> -->

      <li class="nav-item" v-if="permissions.includes('referrals')"
        :class="{ 'link-active': currentPage === 'ReferralStats' }">
        <router-link :to="{ name: 'ReferralStats' }" :class="currentPage === 'ReferralStats' ? 'c-active' : ''"
          target="_self" :aria-current="currentPage === 'ReferralStats' ? 'page' : ''">
          <i data-trigger="hover" data-toggle="tooltip" data-placement="right" class="feather-users"></i>
          <span class="menu-title">Referral Stats</span>
        </router-link>
      </li>

      <li class="nav-item" v-if="permissions.includes('gls')">
        <router-link :to="{ name: 'GLAccount' }" :class="currentPage === 'GLAccount' ? 'c-active' : ''" target="_self"
          :aria-current="currentPage === 'GLAccount' ? 'page' : ''">
          <i data-trigger="hover" data-toggle="tooltip" data-placement="right" class="feather-hash"></i>
          <span class="menu-title">GL Accounts</span>
        </router-link>
      </li>
      <li class="nav-item has-sub menu-collapsed-open" ref="user_management" v-if="permissions.includes('user-management')">
        <a @click="handleClick($event, 'user_management')">
          <i class="feather-users"></i>
          <span class="menu-title">User Management</span>
        </a>
        <ul class="menu-content" @click="itemClicked">
          <li class="nav-item" v-if="permissions.includes('audit-logs')">
            <router-link :to="{ name: 'Logs' }" :class="currentPage === 'Logs' ? 'c-active' : ''" target="_self"
              :aria-current="currentPage === 'Logs' ? 'page' : ''">
              <span class="menu-title">Logs</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="permissions.includes('staffs')">
            <router-link :to="{ name: 'Staffs' }" :class="currentPage === 'Staffs' ? 'c-active' : ''" target="_self"
              :aria-current="currentPage === 'Staffs' ? 'page' : ''">
              <span class="menu-title">Staffs</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="permissions.includes('roles')">
            <router-link :to="{ name: 'Roles' }" :class="currentPage === 'Roles' ? 'c-active' : ''" target="_self"
              :aria-current="currentPage === 'Roles' ? 'page' : ''">
              <span class="menu-title">Roles</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="permissions.includes('admin-tracks')">
            <router-link :to="{ name: 'AdminTracks' }" :class="currentPage === 'AdminTracks' ? 'c-active' : ''" target="_self"
              :aria-current="currentPage === 'AdminTracks' ? 'page' : ''">
              <span class="menu-title">Admin Tracks</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li class="nav-item has-sub menu-collapsed-open" ref="terminal-managment" v-if="permissions.includes('terminals') ||
        permissions.includes('devices') ||
        permissions.includes('terminal-request')
      ">
        <a @click="handleClick($event, 'terminal-managment')">
          <i class="feather-settings"></i>
          <span class="menu-title">Terminal Mgt</span>
        </a>
        <ul class="menu-content" @click="itemClicked">
          <li class="nav-item" v-if="permissions.includes('devices')">
            <router-link :to="{ name: 'TerminalDevices' }" :class="currentPage === 'TerminalDevices' ? 'c-active' : ''"
              target="_self" :aria-current="currentPage === 'TerminalDevices' ? 'page' : ''">
              <span class="menu-title">Devices</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="permissions.includes('terminal-request')">
            <router-link :to="{ name: 'TerminalRequest' }" :class="currentPage === 'TerminalRequest' ? 'c-active' : ''"
              target="_self" :aria-current="currentPage === 'TerminalRequest' ? 'page' : ''">
              <span class="menu-title">Terminal Requests</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="permissions.includes('terminals')">
            <router-link :to="{ name: 'Terminals' }" :class="currentPage === 'Terminals' ? 'c-active' : ''"
              target="_self" :aria-current="currentPage === 'Terminals' ? 'page' : ''">
              <span class="menu-title">Terminals</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li class="nav-item has-sub menu-collapsed-open" ref="reports" v-if="permissions.includes('reports')">
        <a @click="handleClick($event, 'reports')">
          <i class="feather-settings"></i>
          <span class="menu-title">Reports</span>
        </a>
        <ul class="menu-content" @click="itemClicked">
          <li class="nav-item" v-if="permissions.includes('cba-reports')">
            <router-link :to="{ name: 'CbaReports' }" :class="currentPage === 'CaaReports' ? 'c-active' : ''"
              target="_self" :aria-current="currentPage === 'CbaReports' ? 'page' : ''">
              <span class="menu-title">CbaReports</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li class="nav-item has-sub menu-collapsed-open" ref="settingsx" v-if="permissions.includes('system-settings') ||
        permissions.includes('transfer-charges') ||
        permissions.includes('kyc-levels')
      ">
        <a @click="handleClick($event, 'settingsx')">
          <i class="feather-settings"></i>
          <span class="menu-title">Settings</span>
        </a>
        <ul class="menu-content" @click="itemClicked">
          <li class="nav-item" v-if="permissions.includes('system-settings')">
            <router-link :to="{ name: 'SystemSettings' }" :class="currentPage === 'SystemSettings' ? 'c-active' : ''"
              target="_self" :aria-current="currentPage === 'SystemSettings' ? 'page' : ''">
              <span class="menu-title">System Settings</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="permissions.includes('transfer-charges')">
            <router-link :to="{ name: 'ChargesSettings' }" :class="currentPage === 'ChargesSettings' ? 'c-active' : ''"
              target="_self" :aria-current="currentPage === 'ChargesSettings' ? 'page' : ''">
              <span class="menu-title">Transfer Charges Settings</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="permissions.includes('kyc-levels')">
            <router-link :to="{ name: 'CustomerLevel' }" :class="currentPage === 'CustomerLevel' ? 'c-active' : ''"
              target="_self" :aria-current="currentPage === 'CustomerLevel' ? 'page' : ''">
              <span class="menu-title">Customer Level</span>
            </router-link>
          </li>

          <li class="nav-item" v-if="permissions.includes('psuh-notification')">
            <router-link :to="{ name: 'PushNotification' }"
              :class="currentPage === 'PushNotification' ? 'c-active' : ''" target="_self"
              :aria-current="currentPage === 'PushNotification' ? 'page' : ''">
              <span class="menu-title">Push Notifications</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li class="nav-item" v-if="permissions.includes('promos')" :class="{ 'link-active': currentPage === 'Promos' }">
        <router-link :to="{ name: 'Promos' }" :class="currentPage === 'Promos' ? 'c-active' : ''" target="_self"
          :aria-current="currentPage === 'Promos' ? 'page' : ''">
          <i data-trigger="hover" data-toggle="tooltip" data-placement="right" class="feather-bell"></i>
          <span class="menu-title">Promos</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="permissions.includes('promos')" :class="{ 'link-active': currentPage === 'Ads' }">
        <router-link :to="{ name: 'Ads' }" :class="currentPage === 'Ads' ? 'c-active' : ''" target="_self"
          :aria-current="currentPage === 'Ads' ? 'page' : ''">
          <i data-trigger="hover" data-toggle="tooltip" data-placement="right" class="feather-bell"></i>
          <span class="menu-title">Ads</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="permissions.includes('tickets')" :class="{ 'link-active': currentPage === 'Tickets' }">
        <router-link :to="{ name: 'Tickets' }" :class="currentPage === 'Tickets' ? 'c-active' : ''" target="_self"
          :aria-current="currentPage === 'Tickets' ? 'page' : ''">
          <i data-trigger="hover" data-toggle="tooltip" data-placement="right" class="feather-bell"></i>
          <span class="menu-title">Tickets</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="permissions.includes('account-deletion-requests')" :class="{ 'link-active': currentPage === 'AccountDeletionRequests' }">
        <router-link :to="{ name: 'AccountDeletionRequests' }" :class="currentPage === 'AccountDeletionRequests' ? 'c-active' : ''" target="_self"
          :aria-current="currentPage === 'AccountDeletionRequests' ? 'page' : ''">
          <i data-trigger="hover" data-toggle="tooltip" data-placement="right" class="feather-user-x"></i>
          <span class="menu-title">Account Deletion</span>
        </router-link>
      </li>
    </CScrollbar>
  </div>

  <!-- END: Side Menu-->
</template>

<script>
import CRenderFunction from "@/components/CRenderFunction";
import CScrollbar from "@/components/CScrollbar";
import { mapGetters } from "vuex";

export default {
  //
  // nav,
  components: {
    CRenderFunction,
    CScrollbar
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["userObj"]),
    psSettings() {
      // ToDo: find better rtl fix
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX:
          getComputedStyle(document.querySelector("html")).direction !== "rtl",
        wheelPropagation: false
      };
    },
    mustChangePassword() {
      const user = this.userObj || {};
      return user.must_change_password === true || user.must_change_password === 1;
    },
    currentPage() {
      return this.$route.name;
    },
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  },
  methods: {
    handleClick(e, getRef) {
      // console.log(e.target.parentElement.parentElement, e.target);
      e.target.parentElement.parentElement.classList.toggle("open");
    },
    itemClicked(e) {
      return;
    }
  },
  mounted() {
    // this.permissions;
    // or just with selector string
    // const ps = new PerfectScrollbar('.main-menu-content');
  }
};
</script>

<style scoped>
.menu-title {
  font-size: 14px;
  font-family: "Avenir Next W1G Medium";
  vertical-align: middle;
}

[aria-current="page"] {
  color: #fff !important;
  /* border-left: 4px solid #32417E; */
}

.link-active {
  background: #162669;
}

#main-menu-navigation li.nav-item:hover {
  background: #162669;
}

#main-menu-navigation li.nav-item:hover a {
  color: #fff;
}
</style>
